export default __webpack_public_path__ + "static/media/47.69712b90.png";